import React, { Component } from 'react';
import Avatar from 'avataaars';
import AvatarCustomizationGrid from './AvatarCustomizationGrid';
import AvatarOptions from './AvatarOptions';
import { options } from './avatarAttributes';
import html2canvas from 'html2canvas';
import 'bootstrap/dist/css/bootstrap.min.css';

export default class MyAvatarApp extends Component {
  constructor(props) {
    super(props);
    this.avatarContainerRef = React.createRef();
  }

  state = {
    avatarStyle: 'Circle',
    topType: 'ShortHairShortCurly',
    accessoriesType: 'Blank',
    hairColor: 'BrownDark',
    hatColor: 'Blue03',
    facialHairType: 'Blank',
    facialHairColor: 'Blank',
    clotheType: 'BlazerSweater',
    clotheColor: 'PastelBlue',
    mouthType: 'Twinkle',
    skinColor: 'Light',
    selectedCategory: '',
  };

  handleAttributeChange = (category, option) => {
    let updates = { ...this.state };

    if (category === 'top') {
      const isHat = option.type.includes('Hat');
      if (isHat) {
        updates.hatColor = option.color || updates.hatColor;
      } else {
        updates.hairColor = option.color || updates.hairColor;
      }
      updates.topType = option.type;
    } else {
      updates[`${category}Type`] = option.type;
      if (option.color) {
        updates[`${category}Color`] = option.color;
      }
    }

    this.setState(updates);
  };

  captureAvatarAsPNG = () => {
    const svg = this.avatarContainerRef.current.querySelector('svg');
    if (!svg) return;

    const svgBlob = new Blob([svg.outerHTML], { type: 'image/svg+xml;charset=utf-8' });
    const svgUrl = URL.createObjectURL(svgBlob);
    const img = new Image();
    img.src = svgUrl;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext('2d').drawImage(img, 0, 0);

      const a = document.createElement('a');
      a.href = canvas.toDataURL('image/png');
      a.download = 'avatar.png';
      a.click();
    };
  };

  captureAvatarAsSVG = () => {
    const svg = this.avatarContainerRef.current.querySelector('svg');
    if (!svg) return;

    const svgBlob = new Blob([svg.outerHTML], { type: 'image/svg+xml;charset=utf-8' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(svgBlob);
    a.download = 'avatar.svg';
    a.click();
  };

  randomizeAvatar = () => {
    const randomOptions = {};
    const getRandomColor = (colors) => colors[Math.floor(Math.random() * colors.length)];

    for (const category in options) {
      const categoryOptions = options[category];
      const randomOption = categoryOptions[Math.floor(Math.random() * categoryOptions.length)];

      if (category === 'top') {
        randomOptions.topType = randomOption.type;
        if (randomOption.hairColor) {
          randomOptions.hairColor = getRandomColor(randomOption.hairColor);
        }
        if (randomOption.hatColor) {
          randomOptions.hatColor = getRandomColor(randomOption.hatColor);
        }
      } else {
        randomOptions[`${category}Type`] = randomOption.type;
        const colorArray =
          randomOption.hairColor ||
          randomOption.clotheColor ||
          randomOption.facialHairColor ||
          (category === 'skin' ? options.skin.map((o) => o.color) : null);
        if (colorArray) {
          randomOptions[`${category}Color`] = getRandomColor(colorArray);
        }
      }
    }

    this.setState(randomOptions);
  };

  handleCategorySelect = (category) => {
    this.setState((prevState) => ({
      selectedCategory: prevState.selectedCategory === category ? '' : category,
    }));
  };

  toggleAvatarStyle = () => {
    this.setState((prevState) => ({
      avatarStyle: prevState.avatarStyle === 'Circle' ? 'Transparent' : 'Circle',
    }));
  };

  render() {
    return (
      <div className="app-wrapper d-flex flex-column min-vh-100">
        <nav className="navbar sticky-top navbar-light bg-light border-bottom px-3 py-2 d-flex justify-content-between align-items-center">
          <span className="navbar-brand mb-0 h1">🧑‍🎨 Avatar Generator</span>
          <div className="d-flex align-items-center gap-2">
            <button className="btn btn-outline-secondary btn-sm d-flex align-items-center" onClick={this.toggleAvatarStyle} title="Toggle Background">
              <i className="fas fa-toggle-on"></i>
              <span className="d-none d-md-inline ms-1">BG</span>
            </button>
            <button className="btn btn-outline-primary btn-sm d-flex align-items-center" onClick={this.randomizeAvatar} title="Randomize Avatar">
              <i className="fas fa-dice"></i>
              <span className="d-none d-md-inline ms-1">Random</span>
            </button>
            <div className="dropdown">
              <button className="btn btn-outline-success btn-sm dropdown-toggle d-flex align-items-center" type="button" data-bs-toggle="dropdown">
                <i className="fas fa-download"></i>
                <span className="d-none d-md-inline ms-1">Download</span>
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button className="dropdown-item" onClick={this.captureAvatarAsPNG}>
                    PNG
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={this.captureAvatarAsSVG}>
                    SVG
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <div className="container mt-3 flex-grow-1">
          <div className="sticky-avatar">
            <div className="avatar-wrapper d-flex justify-content-center my-3">
              <div className="card shadow-sm p-3 avatar-card" ref={this.avatarContainerRef}>
                <Avatar {...this.state} eyeType={this.state.eyeType} eyebrowType={this.state.eyebrowType} />
              </div>
            </div>
          </div>

          <AvatarCustomizationGrid onCategorySelect={this.handleCategorySelect} />

          <div className="options-container">
            <AvatarOptions category={this.state.selectedCategory} onOptionSelect={this.handleAttributeChange} />
          </div>
        </div>

        <footer className="app-footer text-center py-3">
          <small>👨‍💻 Laget med ❤️ av Sebastian Ingebrigtsen</small>
        </footer>
      </div>
    );
  }
}
